module.exports = "/_next/static/images/AutomaticallyMeasure@3x-1c4e6918fd7a1bf8cbc80192f889afdb.webp";